var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: { "tile is-parent": _vm.isTiled } }, [
    _c("article", { class: { "tile is-child box": _vm.isTiled } }, [
      _c("p", { staticClass: "title" }, [_vm._v("Links")]),
      _c("table", { staticClass: "table is-fullwidth is-narrow" }, [
        _vm._m(0),
        _c(
          "tbody",
          _vm._l(_vm.entity.assets, function (i, idx) {
            return _c(
              "tr",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !i.isDeleted,
                    expression: "!i.isDeleted",
                  },
                ],
                key: idx,
              },
              [
                _c("td", [_vm._v(_vm._s(idx + 1))]),
                _c("td", [_vm._v(_vm._s(_vm.assetTypes[i.assetType - 1]))]),
                _c("td", [_vm._v(_vm._s(i.name))]),
                _c("td", { staticStyle: { "text-align": "right" } }, [
                  _c(
                    "button",
                    {
                      staticClass: "button is-primary is-small is-inverted",
                      on: {
                        click: function ($event) {
                          return _vm.editAsset(i)
                        },
                      },
                    },
                    [_vm._m(1, true)]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "button is-danger is-small is-inverted",
                      on: {
                        click: function ($event) {
                          return _vm.removeAsset(idx)
                        },
                      },
                    },
                    [_vm._m(2, true)]
                  ),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "has-text-right" }, [
        _c(
          "button",
          {
            staticClass: "button is-primary tooltip",
            attrs: { "data-tooltip": "Add new link" },
            on: {
              click: function ($event) {
                return _vm.addAsset()
              },
            },
          },
          [_vm._m(3)]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v(" No. ")]),
        _c("th", [_vm._v(" Type ")]),
        _c("th", [_vm._v(" Name ")]),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-lead-pencil mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-plus mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }